import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {systemSnackbarOptions} from '../store/reducers/globals';
import {useSnackbar} from 'notistack';
import {IconButton} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import {SNACKBAR_COLORS} from '../components/snackbar/systemSnackbarProvider';
import AgyleButton from '../components/ui/buttons/agyleButton';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import {agylePref} from '../store/reducers/preferences';

const DEFAULT_ANCHOR_ORIGIN = {vertical: 'bottom', horizontal: 'left'};

const useStyles = makeStyles((theme) => ({
    snackbar: {
        '&.success': {
            color: SNACKBAR_COLORS.success.color + ' !important',
            borderColor: SNACKBAR_COLORS.success.color + ' !important',
            '&:hover': {
                color: SNACKBAR_COLORS.success.background + ' !important',
                backgroundColor: SNACKBAR_COLORS.success.color + ' !important',
            },
        },
        '&.error': {
            color: SNACKBAR_COLORS.error.color + ' !important',
            borderColor: SNACKBAR_COLORS.error.color + ' !important',
            '&:hover': {
                color: SNACKBAR_COLORS.error.background + ' !important',
                backgroundColor: SNACKBAR_COLORS.error.color + ' !important',
            },
        },
        '&.warning': {
            color: SNACKBAR_COLORS.warning.color + ' !important',
            borderColor: SNACKBAR_COLORS.warning.color + ' !important',
            '&:hover': {
                color: SNACKBAR_COLORS.warning.background + ' !important',
                backgroundColor: SNACKBAR_COLORS.warning.color + ' !important',
            },
        },
        '&.info': {
            color: SNACKBAR_COLORS.info.color + ' !important',
            borderColor: SNACKBAR_COLORS.info.color + ' !important',
            '&:hover': {
                color: SNACKBAR_COLORS.info.background + ' !important',
                backgroundColor: SNACKBAR_COLORS.info.color + ' !important',
            },
        },
    },
}));

function useAgyleSnackbar() {
    const classes = useStyles();

    const agylePreference = useSelector(agylePref);

    // Snackbar
    const snackbarOption = useSelector(systemSnackbarOptions);
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();

    // Update Alerts
    useEffect(() => {
        const action = snackbarId => (
            <>
                {snackbarOption?.action?.length > 0 && snackbarOption?.action?.map((action, index) => (
                    <AgyleButton
                        key={index}
                        onClick={action.event}
                        variant="outlined"
                        size="small"
                        className={clsx(classes.snackbar, snackbarOption.type)}
                    >
                        {action?.label}
                    </AgyleButton>
                ))}

                <IconButton
                    size="small"
                    onClick={() => {
                        closeSnackbar(snackbarId);
                    }}
                    style={{color: SNACKBAR_COLORS?.[snackbarOption.type]?.color || '#000'}}
                >
                    <ClearIcon/>
                </IconButton>
            </>
        );

        if (snackbarOption?.message) {
            enqueueSnackbar(snackbarOption.message, {
                action,
                variant: snackbarOption.type || '',
                anchorOrigin: agylePreference?.snackbar || DEFAULT_ANCHOR_ORIGIN,
            });
        }
    }, [snackbarOption]);
}

export default useAgyleSnackbar;